<template>
  <div>
    <flat-pickr
        v-model="date"
        :config="flatpickrConfig"
        :placeholder="placeholder"
        @onChange="updateValue"
        class="form-control"
        :class="isInvalid ? 'is-invalid' : ''"
    >
    </flat-pickr>
  </div>
</template>
<script>
import i18n from "@/i18n";
export default {
  props: {
    value: {
      type: [Date, String],
      default: null
    },
    placeholder: {
      type: String,
      default: i18n.global.t('base.select-date')
    },
    config: {
      type: Object,
      default: () => ({
        enableTime: false,
        dateFormat: "Y-m-d",
        time_24hr: false,
      })
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: this.value,
    }
  },
  computed: {
    flatpickrConfig() {
      return {
        ...this.config,
        // defaultDate: this.value
      };
    }
  },
  methods: {
    updateValue(selectedDates, dateStr) {
      // console.log(selectedDates)
      this.$emit('update:modelValue', dateStr);
    }
  },
  components: {
  },
  watch: {
    value: {
      handler(val) {
        this.date = val
      }
    }
  }
}
</script>
